module.exports = __webpack_public_path__ + "img/msi-img-first.11f052ef.png";